/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VideoDetailsAnswerUserSpecificInfo,
    VideoDetailsAnswerUserSpecificInfoFromJSON,
    VideoDetailsAnswerUserSpecificInfoFromJSONTyped,
    VideoDetailsAnswerUserSpecificInfoToJSON,
    VideosAnswerFull,
    VideosAnswerFullFromJSON,
    VideosAnswerFullFromJSONTyped,
    VideosAnswerFullToJSON,
} from './';

/**
 * 
 * @export
 * @interface VideoDetailsAnswer
 */
export interface VideoDetailsAnswer {
    /**
     * 
     * @type {VideosAnswerFull}
     * @memberof VideoDetailsAnswer
     */
    videoInfo?: VideosAnswerFull;
    /**
     * 
     * @type {VideoDetailsAnswerUserSpecificInfo}
     * @memberof VideoDetailsAnswer
     */
    userSpecificInfo?: VideoDetailsAnswerUserSpecificInfo;
}

export function VideoDetailsAnswerFromJSON(json: any): VideoDetailsAnswer {
    return VideoDetailsAnswerFromJSONTyped(json, false);
}

export function VideoDetailsAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideoDetailsAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'videoInfo': !exists(json, 'video-info') ? undefined : VideosAnswerFullFromJSON(json['video-info']),
        'userSpecificInfo': !exists(json, 'user-specific-info') ? undefined : VideoDetailsAnswerUserSpecificInfoFromJSON(json['user-specific-info']),
    };
}

export function VideoDetailsAnswerToJSON(value?: VideoDetailsAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'video-info': VideosAnswerFullToJSON(value.videoInfo),
        'user-specific-info': VideoDetailsAnswerUserSpecificInfoToJSON(value.userSpecificInfo),
    };
}


